import React from 'react';
import { FiShoppingCart } from 'react-icons/fi';

const DetailMaterial = ({ workOrder }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  const formatNumber = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  return (
    <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-4 flex items-center space-x-2">
        <FiShoppingCart size={16} />
        <span>Material & Biaya</span>
      </h3>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[var(--bg-secondary)]">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-[var(--text-secondary)]">Item</th>
              <th className="px-4 py-2 text-center text-xs font-medium text-[var(--text-secondary)]">Qty</th>
              <th className="px-4 py-2 text-right text-xs font-medium text-[var(--text-secondary)]">Harga</th>
              <th className="px-4 py-2 text-right text-xs font-medium text-[var(--text-secondary)]">Total</th>
            </tr>
          </thead>
          <tbody>
            {(workOrder.materials && workOrder.materials.length > 0) ? (
              workOrder.materials.map((mat, idx) => {
                const qty = parseInt(mat.qty) || 0;
                const price = parseInt(mat.price) || 0;
                return (
                  <tr key={idx} className="border-t border-[var(--border-color)]">
                    <td className="px-4 py-2 text-[var(--text-primary)]">{mat.name || 'Material'}</td>
                    <td className="px-4 py-2 text-center text-[var(--text-primary)]">{qty}</td>
                    <td className="px-4 py-2 text-right text-[var(--text-primary)]">{formatNumber(price)}</td>
                    <td className="px-4 py-2 text-right font-semibold text-[var(--text-primary)]">{formatNumber(qty * price)}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="4" className="px-4 py-4 text-center text-[var(--text-secondary)]">
                  Tidak ada material
                </td>
              </tr>
            )}

            {(workOrder.laborCost || 0) > 0 && (
              <tr className="border-t border-[var(--border-color)] bg-[var(--bg-secondary)]">
                <td className="px-4 py-2 font-medium text-[var(--text-primary)]">Biaya Pekerjaan / Labor</td>
                <td className="px-4 py-2 text-center text-[var(--text-primary)]">1</td>
                <td className="px-4 py-2 text-right text-[var(--text-primary)]">{formatNumber(workOrder.laborCost || 0)}</td>
                <td className="px-4 py-2 text-right font-semibold text-[var(--text-primary)]">{formatNumber(workOrder.laborCost || 0)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-4 pt-3 border-t border-[var(--border-color)]">
        <div className="flex justify-between items-center">
          <span className="font-semibold text-[var(--text-secondary)]">Total Biaya</span>
          <span className="text-lg font-bold text-[var(--text-primary)]">
            {formatCurrency(workOrder.totalCost || 0)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DetailMaterial;